<template>
  <div>
      <v-btn  @click="openDialog()" :color="ui.bkgdColor" icon>
        <v-icon :color="ui.btnColor"> privacy_tip </v-icon>
      </v-btn>
      <v-dialog v-model="dialog" :max-width="ui.sizeWidthDialogMedium">
        <v-card :color="ui.bkgdColor">
          <v-card-title :class="ui.textTitle">
            Document Revision Edit
            <v-spacer/>
            {{displayDocumentIDGTypeA(getDetailBasic.tag, getDetailBasic.idg)}}
          </v-card-title>
          <v-progress-linear :color="ui.textColor" height="1" value="100">
          </v-progress-linear>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-container>
              <v-layout row class="ml-3">
                <span :class="ui.textSubheadingBold">
                  {{getDetailBasic.title}}
                </span>
                <v-spacer/>
              </v-layout>
              <v-layout row class="mb-4 mr-2">
                <v-spacer/>
                <span :class="ui.textSubheading">
                </span>
                <DocumentStatus :data="{
                  model: 'STD',
                  rev: this.displayDocumentRevTypeA(this.getDetailRev),
                  sec: getDetailRev.sec,
                  stat: getDetailRev.stat,
                  type: getDetailRev.type}
                  "/>
              </v-layout>
              <v-layout row :class="ui.textSubheading">
                <div class="ml-4 mt-2">
                  Document Type - Security - Status
                </div>
              </v-layout>
              <v-layout row wrap class="mr-2">
                <v-flex xs8 offset-xs2>
                  <v-select
                    v-model="localFormEdit.type"
                    :items="docRevTypeOptions"
                    :label="localFormEdit.theme"
                    prepend-icon="bookmark_border"
                    hint="document type"
                    persistent-hint
                    :readonly="lockDocumentTypeChange"
                  >
                  </v-select>
                </v-flex>
                <v-flex xs8 offset-xs2>
                  <v-select
                    v-model="localFormEdit.sec"
                    :items="docRevSecurityOptions"
                    prepend-icon="security"
                    hint="security level"
                    persistent-hint
                  >
                  </v-select>
                </v-flex>
                <v-flex xs8 offset-xs2>
                  <v-select
                    v-model="localFormEdit.stat"
                    :items="docRevStatusOptions"
                    prepend-icon="sync_alt"
                    hint="publication status"
                    persistent-hint
                  >
                  </v-select>
                </v-flex>
              </v-layout>
              <v-layout row :class="ui.textSubheading">
                <div class="ml-4 mt-2">
                  Revision Desciption
                </div>
              </v-layout>
              <v-layout row class="ml-2 mr-2">
                <v-flex xs12>
                  <v-textarea
                  v-model="localFormEdit.com"
                  :outline="true"
                  :rules="mustBeLessThanLargeNotRequired"
                  hint="revision description"
                  auto-grow
                  persistent-hint
                  ></v-textarea>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
          <v-layout row>
            <v-btn @click="closeDialog()" :color="ui.btnColor" flat
            class="hidden-xs-only">
              <v-icon left> exit_to_app </v-icon>
                Close
            </v-btn>
            <v-btn @click="closeDialog()" :color="ui.btnColor" flat
            class="hidden-sm-and-up">
              <v-icon> exit_to_app </v-icon>
            </v-btn>
            <v-spacer/>
            <v-btn @click="changeRevision(true)" :color="ui.btnColor" flat
            v-if="this.localFormEdit.com !== ''">
              <v-icon left> upgrade </v-icon>
                Rev
            </v-btn>
            <v-btn @click="changeRevision(false)" :color="ui.btnColor" flat
            class="hidden-xs-only">
              <v-icon left> create </v-icon>
                Update
            </v-btn>
            <v-btn @click="changeRevision(false)" :color="ui.btnColor" flat
            class="hidden-sm-and-up">
              <v-icon> create </v-icon>
            </v-btn>
          </v-layout>
        </v-card>
      </v-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import revFunctions from "@/data/functions/mixins/revFunctions.js";
import revOptions from "@/data/options/mixins/revOptions.js";
import rulesTextfield from "@/data/rules/mixins/rulesTextfield.js";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import docRevsModFunctions from "@/document/revisions/mixins/docRevsModFunctions.js";
import DocumentStatus from "@/document/revisions/components/DocumentStatus";
import displayFunctions from "@/data/functions/mixins/displayFunctions.js";

export default {
  // eslint-disable-next-line
  mixins: [
    revOptions,
    apptheme,
    docRevsModFunctions,
    rulesTextfield,
    displayFunctions,
    revFunctions
  ],
  computed: {
    ...mapGetters(["getDetailRev", "getDetailBasic"]),
    lockDocumentTypeChange() {
      let logic = null;
      let tag = this.getDetailBasic.tag;
      if (tag === "A1" || tag === "C1" || tag === "F1" || tag === "U1") {
        logic = true;
      } else {
        logic = false;
      }
      return logic;
    }
  },
  components: {
    DocumentStatus
  },
  data() {
    return {
      dialog: false,
      valid: false,
      enableSpinner: false,
      localFormEdit: {
        sec: "", // document security
        type: "", // document type
        stat: "", // document status
        com: "" // justificay
      },
      orgFormEdit: {
        sec: "", // document security
        type: "", // document type
        stat: "", // document status
        com: "" // justificay
      }
    };
  },
  beforeMount() {
    this.localFormEdit.sec = this.getDetailRev.sec;
    this.localFormEdit.type = this.getDetailRev.type;
    this.localFormEdit.stat = this.getDetailRev.stat;
    this.localFormEdit.com = this.getDetailRev.com;

    this.orgFormEdit.sec = this.getDetailRev.sec;
    this.orgFormEdit.type = this.getDetailRev.type;
    this.orgFormEdit.stat = this.getDetailRev.stat;
    this.orgFormEdit.com = this.getDetailRev.com;
  },
  methods: {
    closeDialog() {
      this.dialog = false;
    },
    openDialog() {
      this.dialog = true;
      this.localFormEdit.com = "";
    },
    changeRevision(logic) {
      // REV
      let rev = this.getDetailRev;
      rev.type = this.localFormEdit.type;
      rev.stat = this.localFormEdit.stat;
      rev.sec = this.localFormEdit.sec;
      rev.com = this.localFormEdit.com;

      // UPDATE DOC LOG
      if (this.localFormEdit.type !== this.orgFormEdit.type) {
        this.saveDocumentRevMod(1.61, 1); // tppe update
      }
      if (this.localFormEdit.sec !== this.orgFormEdit.sec) {
        this.saveDocumentRevMod(1.62, 2); // security update
      }
      if (this.localFormEdit.stat !== this.orgFormEdit.stat) {
        this.saveDocumentRevMod(2.81, 3); // other opte
      }
      if (logic === true) {
        this.saveDocumentRevMod(1.63, 4); // user mod
      }

      // RESET ORG
      this.orgFormEdit.type = this.localFormEdit.type;
      this.orgFormEdit.sec = this.localFormEdit.sec;
      this.orgFormEdit.stat = this.localFormEdit.stat;
      this.orgFormEdit.com = this.localFormEdit.com;

      // UPDATE Store
      this.$store.dispatch("changeDataSavePendingIndication", true);
      this.$store.dispatch("changeDetailRev", rev);
      this.dialog = false;

      // HELP
      console.log(logic);
      console.log(this.localFormEdit);
      console.log(this.orgFormEdit);
    }
  }
};
</script>
